import { Component } from '@theme/component';

export class FloatingSocialWidgetComponent extends Component {
  requiredRefs = [
    'popup',
    'closeButton',
    'triggerButton',
  ];

  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;

    document.addEventListener(
      'click',
      this.#handleOutsideClick,
      { signal }
    );

    document.addEventListener(
      'keydown',
      this.#handleEscape,
      { signal }
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
  }

  openWidget() {
    this.refs.popup.classList.add('ms-open');
    this.refs.popup.setAttribute('aria-hidden', 'false');

    this.refs.closeButton.classList.add('ms-visible');
    this.refs.triggerButton.classList.add('ms-hidden');
  }

  closeWidget() {
    this.refs.popup.classList.remove('ms-open');
    this.refs.popup.setAttribute('aria-hidden', 'true');

    this.refs.closeButton.classList.remove('ms-visible');
    this.refs.triggerButton.classList.remove('ms-hidden');
  }

  #handleOutsideClick = (event) => {
    if (
      this.refs.popup.classList.contains('ms-open') &&
      !this.contains(event.target)
    ) {
      this.closeWidget();
    }
  };

  #handleEscape = (event) => {
    if (event.key === 'Escape') {
      this.closeWidget();
    }
  };
}

if (!customElements.get('floating-social-widget')) {
  customElements.define(
    'floating-social-widget',
    FloatingSocialWidgetComponent
  );
}